import React from "react";
import Button from "../../../../../stories/core-components/Button/ButtonUI";
import Icon from "../../../../core-components/IconsSelector";
import * as S from "./NoCarsFound.styles";

interface INocarsFound {
  clearFilter?: () => void;
  title?: string;
  subtitle?: string;
  no_result_image?: string;
}

const NoCarsFoundUI: React.FC<INocarsFound> = ({ clearFilter, title = "No Cars found for the filters applied", subtitle = "Reset filters to view 27 Cars on this route", no_result_image = "" }) => {
  return (
    <S.NoCarsWrapper>
      {no_result_image ?
        <img src={no_result_image} style={{width: '261px'}}/> :
        <Icon
          name="FilterSearch"
          styleProps={{
            width: "11rem",
            height: "12rem",
          }}
        />
      }
      <h4>{title}</h4>
      <p>{subtitle}</p>
      {clearFilter ? (
        <div onClick={clearFilter}>
          <Button
            name="CLEAR FILTERS"
            btnHeight="4.4rem"
            btnWidth="320px"
            fontSize="1.6rem"
          ></Button>
        </div>
      ) : null}
    </S.NoCarsWrapper>
  );
};

export default NoCarsFoundUI;
